document.querySelectorAll('.pcm-swatch-input').forEach(function(input) {
  input.addEventListener('change', function() {
    console.log(input)
    const productId = this.getAttribute('data-product-id');
    const anchor = this.getAttribute('data-anchor');
    console.log(`${anchor ? `${anchor}-` : ''}pcm-img-${productId}`)
    const productImage = document.getElementById(`${anchor ? `${anchor}-` : ''}pcm-img-${productId}`);

    if (!productImage) {
      console.error('❌ Không tìm thấy ảnh product!');
      return;
    }

    const productCard = productImage.closest('.product-card-mini');
    console.log(productCard)
    // 🆕 AUTO-SELECT: Tự động chọn option đầu tiên cho các variant groups khác trong cùng productCard
    const currentIndex = this.getAttribute('data-index');
    const allSwatchGroups = productCard ? productCard.querySelectorAll('.pcm-swatches') : [];
    
    allSwatchGroups.forEach(function(group) {
      const groupIndex = group.getAttribute('data-index');
      const groupProductId = group.getAttribute('data-product-id');

      // Chỉ xử lý các variant groups khác (không phải cái đang onChange)
      if (groupProductId === productId && groupIndex !== currentIndex) {

        const checkedInput = group.querySelector('.pcm-swatch-input:checked');

        if (!checkedInput) {
          // Nếu chưa có gì được chọn, tự động chọn option đầu tiên
          const firstInput = group.querySelector('.pcm-swatch-input');
          if (firstInput) {
            firstInput.checked = true;
          }
        }
      }
    });

    // Lấy swatchGroups: tất cả các option đã chọn (bao gồm cả auto-selected) bên trong đúng productCard hiện tại
    const selectedOptions = [];
    allSwatchGroups.forEach(function(swatchGroup) {
      const index = swatchGroup.getAttribute('data-index');
      const checkedInput = swatchGroup.querySelector('.pcm-swatch-input:checked');
      const optionValue = checkedInput ? checkedInput.getAttribute('data-option-value') : null;
      
      // Gán đúng theo thứ tự index của option
      selectedOptions[index] = optionValue;
    });

    // Lấy variant data từ JSON
    const variantDataElement = document.querySelector(`[data-product-variants="${productId}"]`);
    
    if (!variantDataElement) {
      console.error('❌ Không tìm thấy script JSON chứa variants!');
      return;
    }

    let variantsData;
    try {
      variantsData = JSON.parse(variantDataElement.textContent);
    } catch(e) {
      console.error('❌ Lỗi parse JSON:', e);
      return;
    }

    // Tìm variant khớp với TẤT CẢ options đã chọn
    const matchedVariant = variantsData.variants.find(function(variant) {
      return variant.options.every(function(option, index) {
        return option === selectedOptions[index];
      });
    });

    if (!matchedVariant) {
      console.error('❌ Không tìm thấy variant khớp!');
      return;
    }

    if (!matchedVariant.featured_media) {
      console.error('⚠️ Variant không có featured_media!');
      return;
    }

    // Cập nhật Variant ID cho Hidden Input (nếu có form)
    const form = productCard ? productCard.querySelector('form[id^="product-form-"]') : null;
    const hiddenInput = form ? form.querySelector('.product-variant-id') : null;
    
    if (hiddenInput && form) {
      const originalDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
      hiddenInput.setAttribute('value', matchedVariant.id);
      hiddenInput.value = matchedVariant.id;
      
      Object.defineProperty(hiddenInput, 'value', {
        configurable: true,
        get() {
          return originalDescriptor.get.call(this);
        },
        set(newValue) {
          originalDescriptor.set.call(this, matchedVariant.id);
        }
      });
    }

    // Hiển thị loading
    const wrapper = productImage.closest('.pcm-image-wrapper');
    let oldSpinner = wrapper.querySelector('.spinner_img');
    if (oldSpinner) oldSpinner.remove();
    
    productImage.classList.add('loading-img');
    
    const spinnerHTML = `
      <div class="loading__spinner spinner_img">
        <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>
    `;
    wrapper.insertAdjacentHTML('beforeend', spinnerHTML);

    // Đổi ảnh
    const newImageSrc = matchedVariant.featured_media.src;
    productImage.src = newImageSrc;
    productImage.srcset = '';

    // Update text hiển thị option đang chọn
    allSwatchGroups.forEach(function(group) {
      const groupIndex = group.getAttribute('data-index');
      const checkedInput = group.querySelector('.pcm-swatch-input:checked');
      const optionValueSpan = productCard ? productCard.querySelector(`.option-value[data-index="${groupIndex}"]`) : null;
      
      if (optionValueSpan && checkedInput) {
        optionValueSpan.textContent = checkedInput.getAttribute('data-option-value');
      }
    });

    productImage.onload = function() {
      let spinner = wrapper.querySelector('.spinner_img');
      if (spinner) spinner.remove();
      productImage.classList.remove('loading-img');
    };
    
    productImage.onerror = function() {
      let spinner = wrapper.querySelector('.spinner_img');
      if (spinner) spinner.remove();
      productImage.classList.remove('loading-img');
    };
  });
});